/*
 * Control the visibility and play-ability of the
 * HTML5 video on the U1 template and the homepage.
 *
 * Assesses the state of the video and fires
 * custom event/s to let the other modules
 * know what's up
 *
 * @author max.rolon@barrelny.com
 *
 */

var Video = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.home-page',
			'body.U1-template',
			'body.U1-template-test'
		].join();

		if (!$(templates).length) return;

		this.video = '.video video';

		//Tablet/Mobile doesn't require video
		this.toggleTransperantSection();

		this.events();
	},

	events:function(){
		$('body')
			.on('fullPage__afterLoad',this.pause.bind(this))
			.on('fullPage__onLeave',this.resume.bind(this));

		$(this.video).on('canplaythrough canplay',this.play.bind(this));

		//Check to see if immediately ready
		if ( MUR.videoStateCheck() || MUR.hideVideo() ){
			this.play();
		}

	},

	/*
	 * Play the video and let the rest of the
	 * modules know that the video
	 * about to be played
	 * @params	obj	event object
	 * @returns	void
	 */
	play:function(e){
		var el;

		//This function can only
		//Execute once
		if (this.played) return;
		this.played = true;

		//Passed nada if video
		//is immediately ready
		$(this.video).addClass('playing');

		if (!e){
			el = $(this.video)[0];

			//Delay only for 'feel' (no tech reason)
			setTimeout(function(){
				$('body').trigger('video__skipIntro');
			},100);
		} else {
			el = e.currentTarget;
			$('body').trigger('video__ready');
		}

		el.play();
	},

	/*
	 * Pause the video when it is not in view:
	 * when we have moved past the second
	 * section
	 *
	 * @param	obj	event object
	 * @param	string	anchor link corresponding to the section
	 * @param	string	current section index
	 * @returns	void
	 */
	pause:function(e,anchorLink,index){
		if (index == 3){
			//$(this.video)[0].pause();
		}
	},

	/*
	 * Resume the video if it is paused and
	 * it is about to be in view
	 *
	 * @param	obj	event object
	 * @param	string	index we're moving away from
	 * @param	string	index we're moving towards
	 * @param	string	the direction we are going
	 * @returns	void
	 */
	resume:function(e,index, nextIndex, direction){
		if (nextIndex == 1 || nextIndex == 2) $(this.video)[0].play();
	},

	/*
	 * hide the transperant section that allows
	 * a user to see the video on U1 template
	 * @params	void
	 * @returns	void
	 */
	toggleTransperantSection:function(){
		if ( !$('body').hasClass('U1-template') ) return;

		var
			selector = '.transperant[class^=section-]',
			$el = $(selector);

		if ( MUR.hideVideo() ){
			$el.remove();
			$('body').trigger('fullPage__rebuild');
		}
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		$(this.video).off('canplaythrough');
		this.played = false;
	}
}

module.exports = Video;
